import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import Text from '../Text/Text';
import { capitalizeFirst, textToDate } from 'utils/common';

import classes from './CompanyStatus.module.scss';

const CompanyStatus = ({
  status,
  terminationStatus,
  terminationStatusDate,
  className,
  addStatus
}) => {
  const { t } = useTranslation(['activity']);
  const parsStatus = status.toLowerCase();

  // Build display status with translation
  let displayStatus = status;
  if (parsStatus === 'cancelled' && terminationStatus) {
    displayStatus = `${status} - ${terminationStatus}`;

    // Add date for any cancelattion lifecycle status if available
    if (terminationStatusDate) {
      const formattedDate = textToDate(terminationStatusDate);
      if (formattedDate) {
        displayStatus += ` (${formattedDate})`;
      }
    }
  }

  return (
    <Text
      className={cn(
        classes.status,
        parsStatus === 'active'
          ? classes.status_green
          : parsStatus === 'cancelled'
          ? classes.status_red
          : parsStatus === 'non renewing'
          ? classes.status_blue
          : classes.status_grey,
        className
      )}
      size={2}
    >
      {capitalizeFirst(displayStatus)}
      {addStatus &&
      addStatus !== '-' &&
      addStatus !== 'NA' &&
      addStatus !== 'Customer'
        ? addStatus === 'Currently POC'
          ? ` - ${t('activity:filters.POC_WON')}`
          : ` - ${addStatus}`
        : null}
    </Text>
  );
};

CompanyStatus.propTypes = {
  status: PropTypes.string,
  terminationStatus: PropTypes.string,
  terminationStatusDate: PropTypes.string,
  className: PropTypes.string,
  addStatus: PropTypes.string
};

export default CompanyStatus;
